import { t } from 'i18next'

import {
  formatSettledDay,
  MetricAlertIcon,
  type MetricAlertProps
} from '../MetricAlertIcon'

export function ImpressionShareAlertIcon({
  value,
  settledDay,
  loading = false
}: MetricAlertProps) {
  if (loading) return null

  if (value == null) {
    const date = formatSettledDay(settledDay)

    return (
      <MetricAlertIcon
        ariaLabel={t('rm:alerts.impressionShareAlert')}
        text={
          date
            ? t('rm:alerts.impressionShareFamilyConsolidatedUntil', { date })
            : t('rm:alerts.impressionShareUnavailable')
        }
        variant="warning"
      />
    )
  }

  if (Number(value) === 0) {
    return (
      <MetricAlertIcon
        ariaLabel={t('rm:alerts.impressionShareAlert')}
        text={t('rm:alerts.impressionShareNoImpressions')}
        variant="warning"
      />
    )
  }

  return null
}
